import { waitForNext } from 'ember-simplepractice/utils/waiters';
import Modifier from 'ember-modifier';

export default class CallActionOnChange extends Modifier {
  async modify(_element, [action, ...args]) {
    await waitForNext();

    if (action) {
      action(...args);
    }
  }
}
